import React, { useEffect, useRef } from 'react';
import styles from './Tab.scss';

export interface ITabProps {
    name: string; // needed in Tabs.tsx
    title: string;
    onClick: (ev?: React.MouseEvent) => void;
    href?: string;
    className?: string;
    _active?: boolean; // used in Tabs,tsx
}

const Tab: React.FC<React.PropsWithChildren<ITabProps>> = React.forwardRef(
    ({ name, title, className = '', href = null, onClick = () => {}, _active: active = false }, ref: React.RefObject<HTMLLIElement>) => {
        return (
            <li ref={active ? ref : null} className={[styles.tab, active ? styles.active : null, className].filter((e) => e).join(' ')} onClick={onClick}>
                <a href={href}>{title}</a>
            </li>
        );
    }
);

export default Tab;
